import { isRejectedWithValue } from "@reduxjs/toolkit";
import { enqueueSnackbar } from "notistack";

export const rtkErrorLogger =
 (api) => (next) => (action) => {
  // RTK Query uses `createAsyncThunk` from redux-toolkit under the hood, so we're able to utilize these use matchers!
  if (isRejectedWithValue(action)) {
   enqueueSnackbar(`Error ${action.payload}: /${action.meta.arg.endpointName} - "${action.error.message}"`, {
    variant: "error",
   });
  }
  
  return next(action);
 };

 export const rtkMutationSuccessLogger =
 (api) => (next) => (action) => {
  const { type } = action;
  const isMutation = type.search(/(executeMutation)/) > -1;
  const isFulfilled = type.search(/(fulfilled)/) > -1;
  if(isMutation && isFulfilled){
    enqueueSnackbar(`Success: /${action.meta.arg.endpointName}`, {
      variant: "success",
    });

  }
  return next(action);
 };
